<template>
    <div class="form_root">
      <div class="text-left">
        <h3>
          <router-link to="/usuarios">Usuários</router-link> » {{crud_action}} <button @click.prevent="saveForm()" class="btn btn-success pull-right">Salvar</button>
        </h3>
        <hr>
      </div>
      <div class="form-group col-sm-12">
          <label class="control-label">Cód.</label>
          <input type="text" v-model="form.cod" placeholder="cod" class="form-control" disabled/>
      </div>
      <div class="form-group col-sm-6">
          <label class="control-label">Nome</label>
          <input type="text" v-model="form.nome" placeholder="Nome do Usuário" class="form-control"/>
      </div>
      <div class="form-group col-sm-6">
          <label class="control-label">Login</label>
          <input type="text" v-model="form.login" placeholder="login de acesso" class="form-control"/>
      </div>
      <div class="form-group col-sm-6">
          <label class="control-label">Senha</label>
          <input type="password" v-model="form.pass" placeholder="Senha" class="form-control"/>
      </div>
      <div class="form-group col-sm-6">
          <label class="control-label">Senha - Confirmação</label>
          <input type="password" v-model="pass" placeholder="" class="form-control"/>
      </div>      
    </div>
</template>

<script>
  import swal from 'sweetalert'
  export default {
    name: 'userform',
    components: {},
    data () {
      return {
        crud_action: '',
        pass: '',
        form: {
          cod: 0,
          login: '',
          pass: '',
          nome: '',
          nivel: '0'
        }
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getuser.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response)
            this.form = response.body
          },
          function (error) {
            console.log(error)
          }
        )
      },
      save (form) {
        const url = './api/php/adduser.php'
        this.$http.post(url, JSON.stringify(form)).then(
          function (response) {
            console.log(response.body)
            if (form.cod === 0) {
              swal('Sucesso', form.nome + ' adicionado a lista de usuarios', 'success')
            } else {
              swal('Sucesso', form.nome + ' alterado com sucesso', 'success')
            }
            this.closeForm()
          },
          function (error) {
            console.log(error)
          }
        )
      },
      saveForm () {
        if (this.pass !== this.form.pass) {
          swal('error', 'As senhas de acesso e confirmação são diferentes!', 'error')
          this.pass = ''
          this.form.pass = ''
        } else if (this.form.login === '' || this.form.nome === '') {
          swal('error', 'Login e Nome são campos obrigatórios', 'error')
        } else {
          this.save(this.form)
        }
      },
      remove () {
        const cod = this.form.cod
        const url = './api/php/removeuser.php'
        this.$http.post(url, JSON.stringify({'cod': cod})).then(
          function (response) {
            // console.log(response.body)
            swal('Excluído com sucesso', this.form.nome + ' foi excluído.', 'success')
          },
          function (error) {
            console.log(error)
          }
        )
      },
      closeForm () {
        this.$router.push({path: '/usuarios'})
      }
    },
    created: function () {
      const cod = parseInt(this.$route.params.id)
      if (cod === 0) {
        this.crud_action = 'Novo'
      } else if (cod > 0) {
        this.crud_action = 'Alterando'
        this.load({'cod': cod})
      }
    }
  }
</script>

<style scoped>
    .form_root {
      text-align: left;
      margin-left: 10vw;
      width: 80vw;
    }
    .form_root label {
      color: #444;
    }
    .form_root >>> .form-control {
      padding: 5px;
    }
    .form_root >>> .glyphicon-remove {
      color: #c00;
    }
    .form_root >>> .root ul li {
        background: #e1e1e1;
        margin: 10px;
        padding: 10px;
    }
    .form_root >>> .form {
        background: #ccc;
        padding: 15px 0 15px 0;
    }
    input[type="checkbox"] {
      margin-right: 10px;
    }
    .up {
      text-transform: uppercase;
    }
    .btn-danger {
      margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/UserForm.vue